import { Component, Input, OnInit } from '@angular/core';
import { Solution } from 'src/app/models/service/solution';
import { Capability } from 'src/app/models/service/capability';

@Component({
    selector: 'app-service-tabs-content',
    templateUrl: './service-tabs-content.component.html',
    styleUrls: ['./service-tabs-content.component.scss'],
    standalone: false
})
export class ServiceTabsComponent implements OnInit {

  @Input() service: Solution;
  @Input() capabilities: Capability[];
  @Input() selectedCapabilities: any;
  @Input() displayStartFreeTrialButton: boolean;
  @Input() capabilityDescription: any;
  @Input() solutionVersion: any;

  TabId = TabId;
  selectedTab = TabId.OVERVIEW;

  constructor() { }

  ngOnInit(): void {
  }
}

enum TabId {
  OVERVIEW = 'overview',
  TUTORIALS_AND_DOCUMENTS = 'tutorialsAndDocuments',
}
